<input [id]="field" *ngIf="!disabled && value " type="checkbox" checked (change)="onValueChanged()">
<input [id]="field" *ngIf="!disabled && !value" type="checkbox" (change)="onValueChanged()">

<input [id]="field" *ngIf="disabled && !value" type="checkbox" disabled>
<input [id]="field" *ngIf="disabled && value" type="checkbox" disabled checked>

<label [for]="field"><span style="font-size:15px;">{{"model."+field|translate }}</span></label>